"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";

import SignupAttributionSync from "@/components/ads/signup-attribution-sync";
import PostHogUserIdentity from "@/components/analytics/posthog-user-identity";
import { Toaster } from "@/components/toast/toaster";
import { getQueryClient } from "@/lib/api/query-client";
import { AppStoreProvider } from "@/store/app.store";

export default function SEOProviders({ children }: { children: ReactNode }) {
  const queryClient = getQueryClient();

  return (
    <ClerkProvider>
      <SignupAttributionSync />
      <PostHogUserIdentity />
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={100}>
          <AppStoreProvider initialValues={{ billing: "monthly" }}>
            {children}
            <Toaster />
          </AppStoreProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </ClerkProvider>
  );
}
